import { useMemo } from 'react';
import { SelectComponent, Option } from '../shared/form/SelectComponent';
import { InputContainerProps } from './InputSelectContainer';
import { IIndexable } from '../../model/IIndexable';

type Props<T> = {
  dataOptionsList: T[];
  disable: boolean;
  getLabel: (data: T) => string;
  placeholderTitle: string;
  name: string;
} & InputContainerProps<IIndexable>;

export const FormularioDataExistente = <T,>(props: Props<T>) => {
  const { dataOptionsList, disable, getLabel, placeholderTitle, name, register, errors } = props;

  const options = useMemo<Option[]>(
    () => (Array.isArray(dataOptionsList) ? dataOptionsList.map((data, index) => ({ value: index, title: getLabel(data) })) : []),
    [dataOptionsList, getLabel]
  );

  if (dataOptionsList.length === 0) return <></>;

  return (
    <SelectComponent
      options={options}
      placeholder={placeholderTitle}
      name={name}
      formRegister={register}
      errorCollection={errors}
      required={!disable}
      disabled={disable}
      isNumber={false}
    />
  );
};
